import {type RouteRecordRaw} from "vue-router";

export const PublicRoute: RouteRecordRaw = {
    path: '/public',
    name: 'public',
    meta: { allowAnonymous: true },
    component: () => import('./public.vue'),
};

export default [PublicRoute];

